import { render, staticRenderFns } from "./sessionDetails.vue?vue&type=template&id=3232dcb1"
import script from "./sessionDetails.vue?vue&type=script&lang=js"
export * from "./sessionDetails.vue?vue&type=script&lang=js"
import style0 from "./sessionDetails.vue?vue&type=style&index=0&id=3232dcb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports